/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S6_P2Inputs */

const tr_kullanim_s6_p2 = /** @type {(inputs: Kullanim_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik bedellerindeki değişiklikler en az 30 gün önceden kayıtlı e-posta adresine bildirilir; kabul edilmemesi halinde Kullanıcı yürürlük tarihinden önce aboneliğini feshedebilir.`)
};

const en_kullanim_s6_p2 = /** @type {(inputs: Kullanim_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes to subscription fees are notified to the registered email address at least 30 days in advance; if they are not accepted, the User may terminate the subscription before the effective date.`)
};

const de_kullanim_s6_p2 = /** @type {(inputs: Kullanim_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen der Abonnemententgelte werden mindestens 30 Tage im Voraus an die registrierte E-Mail-Adresse mitgeteilt; werden sie nicht angenommen, kann der Nutzer sein Abonnement vor dem Datum des Inkrafttretens kündigen.`)
};

const ru_kullanim_s6_p2 = /** @type {(inputs: Kullanim_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Об изменениях стоимости подписки сообщается на зарегистрированный адрес электронной почты не менее чем за 30 дней; в случае несогласия Пользователь может расторгнуть подписку до даты вступления изменений в силу.`)
};

/**
* | output |
* | --- |
* | "Changes to subscription fees are notified to the registered email address at least 30 days in advance; if they are not accepted, the User may terminate the s..." |
*
* @param {Kullanim_S6_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s6_p2 = /** @type {((inputs?: Kullanim_S6_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S6_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s6_p2(inputs)
	if (locale === "de") return de_kullanim_s6_p2(inputs)
	if (locale === "ru") return ru_kullanim_s6_p2(inputs)
	return tr_kullanim_s6_p2(inputs)
});